import type { HelpFile } from '../../types/help'
import { AccountStatusHeaderTestIds } from '../../../testids/AccountStatusHeaderTestIds'

export const accountStatusHeaderHelp: HelpFile = {
  docPage: '/docs/admin/lifecycle-events',
  texts: {
    [AccountStatusHeaderTestIds.accountStatusHeaderSummary]:
      'Above-the-fold summary of the most recent account status event — status pair, trigger source, actor, timestamp, and truncated reason.',
    [AccountStatusHeaderTestIds.accountStatusHeaderFromStatus]:
      'Previous account status before this transition. Hidden for the initial creation row.',
    [AccountStatusHeaderTestIds.accountStatusHeaderToStatus]:
      'New account status after this transition. For the initial row this shows "Created as <status>" because there is no fromStatus.',
    [AccountStatusHeaderTestIds.accountStatusHeaderTriggerSource]:
      'Which business process drove the change (USER_ACTION, JML_LEAVER, EXIT_DATE_JOB, etc.).',
    [AccountStatusHeaderTestIds.accountStatusHeaderActor]:
      'The human actor who performed the change. JML cascade events show "System (JML_LEAVER)" since the change was triggered by a leaver event on the parent identity.',
    [AccountStatusHeaderTestIds.accountStatusHeaderTimestamp]:
      'Relative time of the transition. Hover for the absolute timestamp.',
    [AccountStatusHeaderTestIds.accountStatusHeaderReason]:
      'Free-text reason captured at transition time. Truncated at 80 chars; hover to see the full text.',
    [AccountStatusHeaderTestIds.accountStatusHeaderViewTimeline]:
      'Open the full account status timeline tab to see all status changes for this account.',
  },
}
